import React from "react";
import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Tabs,
	Tab
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range } from "lodash";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";
import dayjs from "dayjs";

import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from 'prop-types';
import { filterColumns } from "../column-manager";
import { useHistory } from "react-router-dom";

const durationPulgin = require('dayjs/plugin/duration')
dayjs.extend(durationPulgin)


const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 1 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}


const getTotalWeekOfCurrentMonth = () => {
	return Math.ceil(dayjs().daysInMonth() / 7)
}

const getWeekOfMonth = () => {
	return dayjs.duration().weeks();
}

export const Closed = (props) => {
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	return (
		<Box sx={{ width: '100%' }}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
					<Tab label="COMPLETED" {...a11yProps(0)} />
					<Tab label="BAD DATA" {...a11yProps(1)} />

				</Tabs>
			</Box>
			<CustomTabPanel value={value} index={0}  >
				<List heading={''} sx={{ fontSize: '.1em' }} type={'archive'} socket={props.socket} />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}  >
				<List heading={''} type={'bad'} socket={props.socket} />
			</CustomTabPanel>

		</Box>
	)
}

export const List = ({ heading, type, socket }) => {

	const history = useHistory();

	const {
		roles,
		user,
		users,
		Designations,
		Departments,
		Languages,
		Districts,
		map
	} = useSelector((state) => state.user || {});
	const userStore = useSelector((state) => state.user || {});
	console.log('length', dayjs.duration().asWeeks())

	
	  /**
	   * State for loading the list
	   */
	  const [listLoading, setListLoading] = useState(true);

	const [active, setActive] = useState("Employees");
	const [data, setData] = useState([]);
	const [open, setOpen] = useState(false);
	const [action, setAction] = useState("new");
	const [saved, setSaved] = useState(null);
	const [index, setIndex] = useState(null);
	const [openConfirm, setOpenConfirm] = useState(false);
	const [assigning, setAssigning] = useState(false);
	const [assignCompleted, setAssignCompleted] = useState(false)

	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [count, setCount] = useState(0);
	const [selectedSankalpData, setSelectedSankalpData] = useState(null);
	const [filter, setFilter] = useState({
		from: null,// dayjs("01-01-2023"),
		to: null,//dayjs(),
		cfrom: null,
		cto: null,

		week: getWeekOfMonth()
	});

	useEffect(() => {
		console.log(filter)
	}, [filter])


	useEffect(() => {
		if (socket) {
			socket.on("case-update", (data) => {
				getList(true);
			})
		}
		return () => {
			if (socket) {
				socket.removeAllListeners();
			}
		}
	}, [socket])


	const getList = (keep) => {
		if (!keep) {
			setData([]);
		}

		setListLoading(true);
		axios
			.get(
				API_HOST_CRM +
				`/cases?limit=${rowsPerPage}` +
				`&page=${page}&type=${type}` +
				`${filter.from
					? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
					: ""
				}` +
				`${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
				`${filter.status ? `&status=${encodeURIComponent(JSON.stringify(filter.status))}` : ""}` +
				`${filter.district ? `&district=${encodeURIComponent(JSON.stringify(filter.district))}` : ""}` +
				`${filter.dataType ? `&dataType=${encodeURIComponent(JSON.stringify(filter.dataType))}` : ""}` +
				// `${filter.status ? `&status=${filter.status}` : ""}` +
				// `${filter.district ? `&district=${filter.district}` : ""}` +
				`${filter.motherID ? `&motherId=${filter.motherID}` : ""}` +
				`${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
				`${filter.contact ? `&contact=${filter.contact}` : ""}` +
				`${filter.motherStatus ? `&motherStatus=${encodeURIComponent(JSON.stringify(filter.motherStatus))}` : ""}` +

				// `${filter.telecaller ? `&telecaller=${filter.telecaller}` : ""}` +
				`${filter.telecaller ? `&telecaller=${encodeURIComponent(JSON.stringify(filter.telecaller))}` : ""}` +

				`${filter.allocatedToUser ? `&allocatedToUser=${encodeURIComponent(JSON.stringify(filter.allocatedToUser))}` : ""}` +

				`${filter.dateReceived ? `&dateReceived=${filter.dateReceived}` : ""
				}` +
				`${filter.cfrom
					? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
					: ""
				}` +
				`${filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
				}` +
				`${filter.week ? `&week=${filter.week}` : ""}` +
				`${filter.priority ? `&priority=${encodeURIComponent(JSON.stringify(filter.priority))}` : ""}`

			)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setData(resp.data.cases);
					setCount(resp.data.count);
				}
			})
			.catch((e) => {
				console.log(e);
			})
			.finally(() => {
				setListLoading(false);
			});
	};

	useEffect(() => {
		getList();
	}, [page, rowsPerPage, filter]);

	useEffect(() => {
		getList();
	}, []);

	const exportMotherReport = (data) => {
		axios
			.get(
				API_HOST_CRM +
				`/export-motherData?id=${data.motherID}&from=${encodeURIComponent(
					dayjs(filter.from).format("YYYY-MM-DD")
				)}&to=${encodeURIComponent(dayjs(filter.to).format("YYYY-MM-DD"))}
				
				`,
				{
					responseType: "arraybuffer",
				}
			)
			.then((resp) => {
				if (resp) {
					const url = window.URL.createObjectURL(new Blob([resp.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute(
						"download",
						`Mother_Report_${data.motherID}+${data.name}.xlsx`
					);
					document.body.appendChild(link);
					link.click();
					console.log(resp);
					link.remove();
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<>

			<ToolBar
				name={heading}
				height={'3em'}

				onClearFilter={() => {
					setFilter({
						from: null,
						to: null,
						cfrom: null,
						cto: null,
						firstReceived: null,
						motherName: '',
						motherID: '',
						contact: '',
						status: null,
						motherStatus: null,
						telecaller: null,
						district: null,
					})
				}}
				filters={[


					{
						field: {
							name: "from",
							type: "date",
							label: "Assign From",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
					{
						field: {
							name: "to",
							type: "date",
							label: "Assign To",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},


				]}
			/>
			<Box sx={{ mt: 2 }}>
				<Grid
					data={data}
					isLoading={listLoading}
					columns={[
						...filterColumns(
							[
								{
									id: "motherID",
									showFilter: true,
								},
								{
									id: "name",
									showFilter: true,
								},
								{
									id: "contact",
									showFilter: true
								},
								{
									id: "districtName",
									showFilter: true,
									type: "select"
								},

								{
									id: "dateReceived",
									showFilter: true,
								},
								{
									id: "lastCallDate",
									showFilter: true
								},


								{
									id: "allocatedToUser",
									// showFilter: true,
									isSelect: true
								},
								{
									id: "callDate",
									showFilter: false
								},
							],
							filter,
							setFilter,
							{ Districts, users, map }
						),
					]}
					pagination={{
						rowsPerPageOptions: [10, 25, 50],
						page,
						rowsPerPage,
						onPageChange: (event, newPage) => {
							setPage(newPage);
						},
						onRowsPerPageChange: (event) => {
							setRowsPerPage(+event.target.value);
							setPage(0);
						},
						count,
					}}
					actions={
						user?.roles?.includes(process.env.REACT_APP_ADMIN)
							? [
								{
									name: "Details",
									new: true,
									onClick: (id) => {
										history.push(`/lead/call-data/case-details/${data[id]?.motherID}`);
									},
								},
							]
							: null
					}
				></Grid>
			</Box>

			<Modal
				open={open}
				handleClose={() => {
					setOpen(false);
				}}
				head={`Sankalp Data`}
				buttons={[
					{
						name: "Cancel",
						onClick: () => {
							setOpen(false);
						},
					},
				]}
			>
				{selectedSankalpData &&
					selectedSankalpData.sankalpData &&
					Object.keys(selectedSankalpData.sankalpData).map((s, i) => {
						const map = {
							'pregStatus': 'Pregnancy Status',
							'advice': 'Advice',
							'pregnancyNumber': 'Pregnancy Number',
							'pretermDelivery': 'Pre-term Delivery',
							'nearResidance': 'Near By Residence',
							'trimester': 'Trimester'
						}
						return (
							<Box key={i} sx={{ display: 'flex', mt: 1 }}>
								<Typography variant='p'>{(map[s] || s)}: </Typography>&nbsp;
								<Typography variant='p' sx={{ color: 'grey', fontSize: '.9em' }}>{selectedSankalpData.sankalpData[s]}</Typography>
							</Box>
						)
					})
				}
			</Modal>
		</>
	);
};
